import { Button } from '@maxtropy/components';
import { Image } from 'antd';
import { FC, useState } from 'react';

import powerFactorConfigImag from './powerFactorConfig.png';

export interface PowerFactorConfigModalProps {
  powerTierConfigId?: number;
}

const PowerFactorConfigModal: FC<PowerFactorConfigModalProps> = () => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Button
        onClick={() => setVisible(true)}
        type="link"
        style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0 }}
      >
        点击查看功率因数比例表
      </Button>
      <Image
        width={200}
        style={{ display: 'none' }}
        src={powerFactorConfigImag}
        preview={{
          visible,
          src: powerFactorConfigImag,
          onVisibleChange: value => {
            setVisible(value);
          },
        }}
      />
    </>
  );
};

export default PowerFactorConfigModal;
